import { footer, mainNav, type SiteDef  } from '@luxfi/ui/site-def'

export default {
  app: 'safe',
  currentAs: 'https://safe.lux.network',
  nav: {
    common: mainNav,
  },
  footer: footer.standard,
  chatbot: {
    suggestedQuestions: [
      { heading: 'Lux Safe', message: 'What is a Lux Safe?' },
      { heading: 'Multisig', message: 'How does M-of-N multisig work?' },
      { heading: 'Create', message: 'How do I create a safe?' }
    ]
  },
} satisfies SiteDef



